import { getParent } from "mobx-state-tree";
import { externalEvents } from "@closerplatform/closer-sdk";
import { IRootStore } from "..";
import { WsEventListener } from "@fidget/common/services/eventsListener";
import { ICalendarStore } from "./CalendarStore";

export class CalendarEventListener implements WsEventListener {
  constructor(private _calendarStoreFinder: () => ICalendarStore, public name: string) {}

  get calendarStore() {
    return this._calendarStoreFinder();
  }

  //// meetings events
  meetingScheduled(event: externalEvents.MeetingScheduled) {
    const rootStore = getParent(this.calendarStore) as IRootStore; // TODO: discover wth is going on here
    if (!rootStore || rootStore.currentUserStore.id !== event.adviserId) {
      return;
    }
    this.calendarStore.addMeeting({ ...event, id: event.meetingId });
  }

  meetingRescheduled(event: externalEvents.MeetingRescheduled) {
    this.calendarStore.updateMeeting({ ...event, id: event.meetingId });
  }

  meetingCancelled(event: externalEvents.MeetingCancelled) {
    this.calendarStore.removeMeeting(event.meetingId);
  }

  //// guests event
  guestProfileUpdated(event: externalEvents.GuestProfileUpdated) {
    const guest = this.calendarStore.guests.get(event.customerId);
    if (guest) {
      guest.updateFromEvent(event);
    }
  }

  connected() {
    this.calendarStore.setup();
  }
}
